import { render, staticRenderFns } from "./dialog-edit-passwd.vue?vue&type=template&id=079e6756&scoped=true"
import script from "./dialog-edit-passwd.vue?vue&type=script&lang=js"
export * from "./dialog-edit-passwd.vue?vue&type=script&lang=js"
import style0 from "./dialog-edit-passwd.vue?vue&type=style&index=0&id=079e6756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e6756",
  null
  
)

export default component.exports